import React from 'react';
import SwiperCore, { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Breakpoints from 'themes/constants/breakpoints';
import { IBooksData, IBooksDetailData } from 'constants/types';
import Loader from 'components/Loader/Loader';
import { useMediaQuery } from 'react-responsive';
import { BooksType } from 'components/Books/card/BooksCardTypes';
import { BooksSliderMainBooksCard, BooksSliderMainWrap } from './BooksSliderMainStyles';

const settings = {
  spaceBetween: 24,
  slidesPerView: 1.5,
  autoplay: false,
  centeredSlides: false,
  scrollbar: {
    draggable: true,
  },
  watchSlidesVisibility: true,
  preloadImages: false,
  breakpoints: {
    470: {
      slidesPerView: 2.5,
      spaceBetween: 24,
    },
    690: {
      slidesPerView: 3.5,
      spaceBetween: 24,
    },
    900: {
      slidesPerView: 4.5,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 5.5,
      spaceBetween: 24,
    },
    1250: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 6,
      spaceBetween: 24,
      centeredSlides: false,
    },
    1350: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 7,
      spaceBetween: 24,
    },
    1530: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 8,
      spaceBetween: 24,
    },
  },
};

interface IBooksSliderMain {
  data: IBooksData
  loading?: boolean
  isDark?: boolean
  priorityPreview?: BooksType
}

SwiperCore.use([Scrollbar, Navigation]);

const BooksSliderMain = (props: IBooksSliderMain) => {
  const {
    data,
    loading = false,
    isDark = false,
    priorityPreview = BooksType.EBOOK,
  } = props;

  const isLaptopL = useMediaQuery({ query: `(${Breakpoints.LAPTOP_L})` });

  const navButton = (
    <>
      <div className="swiper-button-next" />
      <div className="swiper-button-prev" />
    </>
  );

  return (
    <BooksSliderMainWrap
      isDark={isDark}
    >
      {loading
        ? <Loader />
        : (
          <Swiper {...settings}>
            {Array.isArray(data) ? data?.map((item: IBooksDetailData) => (
              <SwiperSlide key={item?.bookId}>
                {({ isVisible }) => {
                  const opacity = isVisible ? 1 : 0.5;
                  return (
                    <BooksSliderMainBooksCard
                      item={item}
                      priorityPreview={priorityPreview}
                      opacity={opacity}
                    />
                  );
                }}
              </SwiperSlide>
            )) : null}
            {isLaptopL ? navButton : null}
          </Swiper>
        )}
    </BooksSliderMainWrap>
  );
};

export default BooksSliderMain;
